export const PaymentAuthenticatedComponent = {
    template: `
        <oo-card ng-if="!$ctrl.isLoading">
            <oo-card-header>
                <p>Payment</p>
            </oo-card-header>

            <oo-card-body>
                <div class="column column-sm-12 expand">
                    <payment-method></payment-method>
                </div>
                <div class="column column-sm-12 expand fold-animation" ng-if="$ctrl.shouldShowCash()">
                    <cash></cash>
                </div>
                <oo-edit-pane
                    on-cancel="$ctrl.rollback()"
                    on-submit="$ctrl.saveCard()"
                    ng-if="$ctrl.shouldShowCard()"
                    missing-data="$ctrl.missingData()"
                >
                    <oo-read-state>
                        <credit-card-card class="card-display-offset" card="$ctrl.paymentService.data.selectedPayment"></credit-card-card>
                        <oo-tip ng-if="$ctrl.tipEnabled"></oo-tip>
                    </oo-read-state>
                    <oo-edit-state>
                        <credit-card-picker></credit-card-picker>
                    </oo-edit-state>
                </oo-edit-pane>
        </oo-card>
    `,
    controller: class {
        constructor(accountService, checkoutService, paymentService, restaurantInfoFactory, $q) {
            'ngInject';
            this.accountService = accountService;
            this.checkoutService = checkoutService;
            this.paymentService = paymentService;
            this.restaurantInfoFactory = restaurantInfoFactory;
            this.$q = $q;
            this.tipEnabled = false;
            this.isLoading = true;
        }

        $onInit() {
            this.paymentService.initialize();
            let cardsDfd = this.accountService.getCards()
                .then(() => this.selectFirstCard());

            let restaurantInfoDfd = this.restaurantInfoFactory.getInfo(['info'])
                .then(info => this.tipEnabled = info.onlineOrder.paymentOptions.ccTipEnabled);

            this.$q.all([cardsDfd, restaurantInfoDfd])
                .finally(() => this.isLoading = false);

        }

        shouldShowCash() {
            return this.paymentService.data.cashPayment &&
                this.paymentService.data.selectedPayment.method === 'CASH';
        }

        shouldShowCard() {
            return this.paymentService.data.cardPayment &&
                this.paymentService.data.selectedPayment.method === 'CREDIT';
        }

        missingData() {
            return !this.paymentService.validateFast();
        }

        rollback() {
            this.paymentService.rollback();
            return true;
        }

        selectFirstCard() {
            let cards = this.accountService.data.cards;
            const hasSavedPayment = !!this.paymentService.data.selectedPayment.guid;
            if(cards.length && !hasSavedPayment) {
                this.paymentService.setCreditCardPayment(cards[0]);
            }
        }

        saveCard() {
            this.paymentService.setCreditCardPayment(this.paymentService.data.tempPayment);
            return this.$q.resolve('');
        }
    }
};
